import { render } from "./ContentSiteFooter.vue?vue&type=template&id=a84e0ec2"
import script from "./ContentSiteFooter.vue?vue&type=script&lang=js"
export * from "./ContentSiteFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__